export class ColourCodesTheme {

    public l_ThemeBlue: string = '#2a457a';
    public l_Green: string = '#008000';
    public l_Red: string = '#CD1C18';
    public l_WarnYellow: string = '#DBA400';
  
    constructor(init?: Partial<ColourCodesTheme>) {
      Object.assign(this, init);
    }
  }